import { reactive } from "vue";

// 仅回放覆盖设备判断：优先使用录制模式，旧数据按宽度推断；正常访客仍沿用原 UA 判断。
export const replayViewport = reactive({ width: window.innerWidth, height: window.innerHeight, deviceMode: "" });
export function setReplayViewport(snapshot) {
  replayViewport.width = snapshot.width;
  replayViewport.height = snapshot.height;
  replayViewport.deviceMode = snapshot.deviceMode || (snapshot.width <= 768 ? "mobile" : "desktop");
}
export function replayDeviceMode() {
  if (!new URLSearchParams(window.location.search).has("ip")) return "";
  return replayViewport.deviceMode || (replayViewport.width <= 768 ? "mobile" : "desktop");
}
